import { Select, Table, TableColumnsType } from 'antd';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Button from '../../../components/Button';
import Footer from '../../../components/layout/Footer';
import { useEffect, useState } from 'react';
import config from '../../../lib/config';
import { useHistory, useLocation, useRouteMatch } from 'react-router';
import QueryString from 'qs';
import Pagination from '../../../components/Pagination';
import useAxios from '../../../hooks/useAxios';
import { IGetSemesters } from '../../../models/semesters.model';
import { getSemesters } from '../../../api/semesters.api';
import { IGetSteps } from '../../../models/courses.model';
import Loader from '../../../components/Spinner';
import ErrorResponse from '../../../components/ErrorResponse';
import { getSteps } from '../../../api/courses.api';
import { ICampusClass, IGetCampusClasses } from '../../../models/campusClasses4.model';
import { getCampusClasses } from '../../../api/campusClasses4.api';
import {
  ICampusStudentParams,
  IGetCampusStudents,
} from '../../../models/coupons.model';
import {
  createStudentCoupons,
  getCampusStudents,
} from '../../../api/coupons.api';
import { useTranslation } from 'react-i18next';
import { getCommonCodeLabel } from '../../../lib/store';
import Checkbox from '../../../components/Checkbox';
import useNotification from '../../../hooks/useNotification';
import ConfirmModal from '../../../components/modals/ConfirmModal';

interface IMatch {
  campusCode: string;
  couponCode: string;
}

const PaymentCouponIssue = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const match = useRouteMatch<IMatch>();
  const campusCode = match.params.campusCode;
  const couponCode = Number(match.params.couponCode);
  const { successNotification, infoNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetSemesters>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetSteps>();
  const {
    data: res3,
    isLoading: isLoading3,
    error: error3,
    execute: execute3,
  } = useAxios<IGetCampusClasses>();
  const {
    data: res4,
    isLoading: isLoading4,
    error: error4,
    execute: execute4,
  } = useAxios<IGetCampusStudents>();
  const {
    data: createRes,
    isLoading: createIsLoading,
    error: createError,
    execute: createExecute,
  } = useAxios();

  const [page, setPage] = useState(1);
  const [semesterCode, setSemesterCode] = useState<number>();
  const [level, setLevel] = useState<number|null>();
  const [levelList, setLevelList] = useState<any>();
  const [step, setStep] = useState<number|null>();
  const [stepList, setStepList] = useState<any>();
  const [classCode, setClassCode] = useState<string>();
  const [classCodeList, setClassCodeList] = useState<ICampusClass[]>([]);
  const [studentName, setStudentName] = useState<string>('');
  const [selects, setSelects] = useState<any>([]);
  const [isSelectAll, setIsSelectAll] = useState<boolean>(false);
  const [issueCouponsVisible, setIssueCouponsVisible] =
    useState<boolean>(false);
  const all = { label: t('common.text.all'), value: null };

  useEffect(() => {
    execute(getSemesters());
    execute2(getSteps());
    execute3(getCampusClasses(campusCode));
  }, []);

  useEffect(() => {
    if (!location.search) return;

    // query to state
    if (query.semesterCode) {
      setSemesterCode(Number(query.semesterCode));
    }
    if (query.level) {
      setLevel(Number(query.level));
    }
    if (query.step) {
      setStep(Number(query.step));
    }
    if (query.classCode) {
      setClassCode(String(query.classCode));
    }

    // call api
    const params: ICampusStudentParams = {};
    if (semesterCode) params.semesterCode = semesterCode;
    if (level) params.levelCode = level;
    if (step) params.courseCode = step;
    if (classCode) params.classCode = classCode;
    if (studentName) {
      if (i18n.language === 'ko') params.korName = studentName;
      else params.engName = studentName;
    }

    execute4(getCampusStudents(campusCode, params));
    setPage(1);
  }, [location]);

  useEffect(() => {
    if (res2 && !isLoading2) {
      const data: any = [all];
      const _allSteps: any = [];
      res2.data.forEach((level) => {
        data.push({
          label: level.courseName,
          value: level.courseCode,
        });
        level.step?.forEach((step) => {
          _allSteps.push({
            levelCode: level.courseCode,
            levelName: level.courseName,
            stepCode: step.courseCode,
            stepName: step.courseName,
          });
        });
      });
      setLevel(undefined);
      setLevelList(data);
      setStep(undefined);
      setStepList([all]);
    }
  }, [res2, isLoading2]);

  useEffect(() => {
    if (res3 && !isLoading3) {
      console.log('res3.data', res3.data);
      setClassCodeList(res3.data);
    }
  }, [res3, isLoading3]);

  useEffect(() => {
    if (createRes && !createIsLoading) {
      successNotification(t('student.student.message40'));
      setIssueCouponsVisible(false);
      history.push(`/payment/coupon/${campusCode}/${couponCode}/list`);
    }
  }, [createRes, createIsLoading]);

  const onSearch = () => {
    if (!semesterCode) {
      return infoNotification(t('homepage.survey.message2'));
    }

    const param: any = { semesterCode };

    if (level) param.level = level;
    if (step) param.step = step;
    if (classCode) param.classCode = classCode;
    if (studentName) param.studentName = studentName;

    history.push(`/payment/coupon/${campusCode}/${couponCode}/issue?${QueryString.stringify(param)}`);
  };

  const onSetLevel = (value: number) => {
    setStep(undefined);
    setClassCode(undefined);
    setLevel(value);

    if (value) {
      const level = res2?.data?.find(item => Number(item.courseCode) === value);
      if (level) {
        const data: any = [all];
        level.step?.forEach((item) => {
          data.push({
            label: item.courseName,
            value: item.courseCode,
          });
        });
        setStepList(data);
        setClassCodeList(res3?.data?.filter(item => item.levelName === level.courseName) || []);
      }
    } else {
      setStepList([all]);
      setClassCodeList(res3?.data || []);
    }
  };

  const onSetStep = (value: number) => {
    setClassCode(undefined);
    setStep(value);

    if (value) {
      const step = stepList.find((step: any) => Number(step.value) === value);
      if (step) {
        setClassCodeList(res3?.data?.filter(item => item.courseName === step.label) || []);
      }
    } else {
      const level = res2?.data?.find(item => Number(item.courseCode) === value);
      if (level) {
        setClassCodeList(res3?.data?.filter(item => item.levelName === level.courseName) || []);
      }
    }
  };

  const onSetSelects = (memberCode: string) => {
    if (selects.includes(memberCode)) {
      setSelects(selects.filter((item: string) => item !== memberCode));
      setIsSelectAll(false);
    } else {
      setSelects([...selects, memberCode]);
    }
  };

  const onSelectAll = () => {
    if (isSelectAll) {
      setSelects([]);
      setIsSelectAll(false);
    } else {
      setSelects(res4?.data?.map((item) => item.memberCode));
      setIsSelectAll(true);
    }
  };

  const onConfirmIssueCoupons = () => {
    if (selects.length === 0) {
      return infoNotification(t('payment.coupon.message1'));
    }

    setIssueCouponsVisible(true);
  };

  const onIssueCoupons = () => {
    createExecute(createStudentCoupons(couponCode, { memberCode: selects }));
  };

  const columns: TableColumnsType<any> = [
    {
      title: t('payment.coupon.column1'),
      dataIndex: 'studentKorName',
      key: 'studentKorName',
      align: 'center',
      sorter: (a, b) => a.studentKorName?.localeCompare(b.studentKorName),
    },
    {
      title: t('payment.coupon.column7'),
      dataIndex: 'schoolName',
      key: 'schoolName',
      align: 'center',
      sorter: (a, b) => a.schoolName?.localeCompare(b.schoolName),
    },
    {
      title: t('payment.coupon.column8'),
      dataIndex: 'gradeCode',
      key: 'gradeCode',
      align: 'center',
      sorter: (a, b) => a.createEndDate?.localeCompare(b.createEndDate),
      render: (value) => getCommonCodeLabel('SY0006', value?.trim(), 'ko'),
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      key: 'className',
      align: 'center',
    },
    {
      title: <Checkbox checked={isSelectAll} onChange={onSelectAll} text="" />,
      dataIndex: 'memberCode',
      key: 'memberCode',
      align: 'center',
      render: (value: string) => {
        let checked = false;
        if (selects.includes(value) || isSelectAll) checked = true;

        return (
          <Checkbox
            checked={checked}
            onChange={() => onSetSelects(value)}
            text=""
          />
        );
      },
    },
  ];

  return (
    <>
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.column.semester')}</label>
            <div className="w-100p">
              <Select
                className="w-100"
                placeholder={t('common.column.semester')}
                value={semesterCode}
                onChange={(value) => setSemesterCode(value)}
              >
                {res?.data.map((item: any) => (
                  <Select.Option
                    key={item.semesterCode}
                    value={item.semesterCode}
                  >
                    {item.semesterName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('payment.coupon.column14')}</label>
            <div className="w-100p">
              <Select
                className="w-100"
                placeholder={t('payment.coupon.column14')}
                value={level}
                onChange={(value) => onSetLevel(value)}
              >
                {levelList?.map((item: any) => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('payment.coupon.column15')}</label>
            <div className="w-100p">
              <Select
                className="w-100"
                placeholder={t('payment.coupon.column15')}
                value={step}
                onChange={(value) => onSetStep(value)}
              >
                {stepList?.map((item: any) => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('common.menu.class')}</label>
            <div className="w-100p">
                <Select
                  className="w-100"
                  placeholder={t('common.menu.class')}
                  value={classCode}
                  onChange={(value) => setClassCode(value)}
                >
                  <Select.Option value="">{t('common.text.all')}</Select.Option>
                  {classCodeList.map((item: ICampusClass) => (
                    <Select.Option
                      key={item.classCode}
                      value={item.classCode}
                    >
                      {item.className}
                    </Select.Option>
                  ))}
                </Select>
              </div>
          </li>
          <li>
            <label>{t('payment.coupon.placeholder2')}</label>
            <input
              type="text"
              className="form-control w-120p"
              placeholder={t('payment.coupon.placeholder2')}
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') onSearch();
              }}
            />
            <div className="comm-btn__area">
              <Button
                className="btn-basic small black"
                onClick={onSearch}
                text={t('common.button.search')}
              />
            </div>
          </li>
          <li>
            <label></label>
          </li>

        </ul>
      </div>
    </div>

    <div className="content scrollbar">
      {isLoading ||
      isLoading2 ||
      isLoading3 ||
      isLoading4 ||
      createIsLoading ? (
        <Loader />
      ) : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={error4} />
      <ErrorResponse error={createError} />
      <SimpleHeader parentMenu={t('common.menu.payment')} currentMenu={t('payment.coupon.title1')} onlyTitle={true} />

      <div className="col-frame">
        <div className="comm-bx__between">
          <div className="comm-sch_result">{t('archive.exam.text1')}: <b>{res4?.data.length}</b>{t('common.text.unit')}</div>
          <div className="comm-btn__area">
            <Button
              className="btn-basic pink"
              onClick={onConfirmIssueCoupons}
              text={t('payment.coupon.button2')}
            />
          </div>
        </div>
        <div className='comm-table__area'>
          <Table
            columns={columns}
            dataSource={res4?.data}
            pagination={{
              current: page,
              pageSize: config.pageSize,
            }}
          />
        </div>
        <div className="comm-bx__between">
          <div className="comm-btn__area">
            <Button
              className="btn-basic gray-line"
              onClick={() =>
                history.push(`/payment/coupon/${campusCode}/${couponCode}/list`)
              }
              text={t('common.button.back')}
            />
          </div>
          <div className="common-paging center">
            <Pagination
              count={res4?.data.length || 0}
              page={page}
              setPage={setPage}
            />
          </div>
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink"
              onClick={onConfirmIssueCoupons}
              text={t('payment.coupon.button2')}
            />
          </div>
        </div>
      </div>
      <Footer />

      {issueCouponsVisible && (
        <ConfirmModal
          visible={issueCouponsVisible}
          setVisible={setIssueCouponsVisible}
          onConfirm={onIssueCoupons}
          titleText={t('payment.coupon.title2')}
          messageText={t('payment.coupon.text3')}
          confirmText={t('payment.coupon.button2')}
          cancelText={t('common.button.cancel')}
        />
      )}
    </div>
    </>
  );
};

export default PaymentCouponIssue;
